export const DEFAULT_AUTO_LOCALE = 'auto';
export const DEFAULT_SOURCE_INFO = {};
export const DEFAULT_TIMEOUT_POLICY = 'MEDIUM';
export const DEFAULT_AB_TESTS = {};
